import React from 'react';

/**
 * Reusable pagination bar for list pages.
 * Props: currentPage, totalPages, totalCount, pageSize, onPageChange
 */
const PaginationBar = ({ currentPage, totalPages, totalCount, pageSize, onPageChange, testIdPrefix = 'page' }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 7;
  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);
  if (start > 1) { pages.push(1); if (start > 2) pages.push('...'); }
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < totalPages) { if (end < totalPages - 1) pages.push('...'); pages.push(totalPages); }

  return (
    <div className="flex items-center justify-center gap-1 py-3" data-testid={`${testIdPrefix}-pagination`}>
      <button
        className="px-3 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        data-testid={`${testIdPrefix}-prev`}
      >Prev</button>
      {pages.map((p, i) => p === '...' ? (
        <span key={`dots-${i}`} className="px-2 py-1.5 text-gray-400">...</span>
      ) : (
        <button key={p}
          className={`px-3 py-1.5 text-sm rounded-md border ${p === currentPage ? 'bg-emerald-600 text-white border-emerald-600 font-bold' : 'border-gray-300 hover:bg-gray-100'}`}
          onClick={() => onPageChange(p)}
          data-testid={`${testIdPrefix}-${p}`}
        >{p}</button>
      ))}
      <button
        className="px-3 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        data-testid={`${testIdPrefix}-next`}
      >Next</button>
      <span className="text-xs text-gray-500 ml-3">
        Showing {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} of {totalCount}
      </span>
    </div>
  );
};

export default PaginationBar;
